<template>
  <div class="relative inline-flex">
    <Popover v-slot="{ open }" class="relative">
      <PopoverButton
        :class="buttonSizeClass"
        :aria-label="$t('Share')"
        :title="$t('Share')"
        class="inline-flex items-center gap-1.5 rounded-xl border border-neutral-300 bg-white text-sm font-semibold text-neutral-700 shadow-sm transition-all duration-200 hover:border-brand-300 hover:text-brand-800 hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2"
      >
        <svg :class="iconSizeClass" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="CurrentColor" version="1.1" id="Capa_1" viewBox="0 0 227.216 227.216" xml:space="preserve">
          <path d="M175.897,141.476c-13.249,0-25.11,6.044-32.98,15.518l-51.194-29.066c1.592-4.48,2.467-9.297,2.467-14.317  c0-5.019-0.875-9.836-2.467-14.316l51.19-29.073c7.869,9.477,19.732,15.523,32.982,15.523c23.634,0,42.862-19.235,42.862-42.879  C218.759,19.229,199.531,0,175.897,0C152.26,0,133.03,19.229,133.03,42.865c0,5.02,0.874,9.838,2.467,14.319L84.304,86.258  c-7.869-9.472-19.729-15.514-32.975-15.514c-23.64,0-42.873,19.229-42.873,42.866c0,23.636,19.233,42.865,42.873,42.865  c13.246,0,25.105-6.042,32.974-15.513l51.194,29.067c-1.593,4.481-2.468,9.3-2.468,14.321c0,23.636,19.23,42.865,42.867,42.865  c23.634,0,42.862-19.23,42.862-42.865C218.759,160.71,199.531,141.476,175.897,141.476z M175.897,15  c15.363,0,27.862,12.5,27.862,27.865c0,15.373-12.499,27.879-27.862,27.879c-15.366,0-27.867-12.506-27.867-27.879  C148.03,27.5,160.531,15,175.897,15z M51.33,141.476c-15.369,0-27.873-12.501-27.873-27.865c0-15.366,12.504-27.866,27.873-27.866  c15.363,0,27.861,12.5,27.861,27.866C79.191,128.975,66.692,141.476,51.33,141.476z M175.897,212.216  c-15.366,0-27.867-12.501-27.867-27.865c0-15.37,12.501-27.875,27.867-27.875c15.363,0,27.862,12.505,27.862,27.875  C203.759,199.715,191.26,212.216,175.897,212.216z"/>
        </svg>

        <template v-if="showTitle">{{ $t('Share') }}</template>
        <font-awesome-icon
          icon="fa-solid fa-chevron-down"
          class="h-3 w-3 text-neutral-500 transition-transform duration-200"
          :class="open ? 'rotate-180' : ''"
        />
      </PopoverButton>

      <transition
        enter-active-class="transition duration-200 ease-out"
        enter-from-class="translate-y-1 opacity-0"
        enter-to-class="translate-y-0 opacity-100"
        leave-active-class="transition duration-150 ease-in"
        leave-from-class="translate-y-0 opacity-100"
        leave-to-class="translate-y-1 opacity-0"
      >
        <PopoverPanel class="absolute left-1/2 z-30 mt-2 w-64 -translate-x-1/2 rounded-2xl border border-neutral-200 bg-white p-3 shadow-[0_18px_30px_-18px_rgba(17,24,39,0.25)]">
          <div class="mb-2 text-xs font-semibold uppercase tracking-wide text-neutral-500">{{ $t('Share') }}</div>
          <div class="grid grid-cols-4 gap-2">
            <a :href="share('whatsapp')" target="_blank" rel="noopener noreferrer" class="share-item" :title="$t('WhatsApp')">
              <font-awesome-icon class="h-5 w-5 text-green-600" :icon="['fab', 'whatsapp']" />
            </a>
            <a :href="share('facebook')" target="_blank" rel="noopener noreferrer" class="share-item" :title="$t('Facebook')">
              <font-awesome-icon class="h-5 w-5 text-blue-700" :icon="['fab', 'facebook']" />
            </a>
            <a :href="share('twitter')" target="_blank" rel="noopener noreferrer" class="share-item" :title="$t('X')">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" class="h-5 w-5 text-neutral-900">
                <path fill="currentColor" d="M 5.9199219 6 L 20.582031 27.375 L 6.2304688 44 L 9.4101562 44 L 21.986328 29.421875 L 31.986328 44 L 44 44 L 28.681641 21.669922 L 42.199219 6 L 39.029297 6 L 27.275391 19.617188 L 17.933594 6 L 5.9199219 6 z M 9.7167969 8 L 16.880859 8 L 40.203125 42 L 33.039062 42 L 9.7167969 8 z"></path>
              </svg>
            </a>
            <button type="button" @click="share('copy')" class="share-item" :title="$t('Copy Link')">
              <font-awesome-icon class="h-5 w-5 text-brand-800" :icon="['fas', 'copy']" />
            </button>
          </div>
        </PopoverPanel>
      </transition>
    </Popover>
  </div>
 </template>
 <script setup>
 import { computed, ref } from 'vue';
 import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
 const { setNotify} = useCommon();
 
 const props = defineProps({
   showTitle: {
     type:Boolean,
     default: true
   },
   title:{
     type:String,
     default: 'Look at this inanctur.com.tr'
   },
   url:{
     type:String,
     default: null
   },
   size:{
     type:String,
     default: "sm"
   }
 })

 const buttonSizeClass = computed(() => {
   if (props.size === 'xs') {
     return 'px-1.5 py-1 text-xs';
   }

   if (props.size === 'sm') {
     return 'px-3 py-2';
   }

   return 'px-3.5 py-2.5';
 });

 const iconSizeClass = computed(() => {
   if (props.size === 'xs') {
     return 'h-3 w-3';
   }

   return 'h-3.5 w-3.5';
 });
 
 const share = (ws)=>{
   let t = props.title;
   let pageUrl = props.url || window.location.href;
 
   if(ws=='copy'){
 
       const body = document.querySelector('body');
       const area = document.createElement('textarea');
       body.appendChild(area);
 
       area.value = props.url || window.location.href;
       area.select();
       document.execCommand('copy');
 
         setNotify({
                             show: true,
                             type: "success",
                             text: "Succesfully copied.",
                             title: "Succesfull"
                         })
        return '#';
   }else
   if(ws=='whatsapp'){
       return `https://api.whatsapp.com/send?text=${t}`
   }else if(ws=='twitter'){
       return `https://x.com/intent/tweet?url=${pageUrl}&text=${t}`
   }else if(ws=='facebook'){
       return `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}&text=${t}`
   }
 }
 
 </script>
<style scoped>
.share-item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem;
  width: 100%;
  border-radius: 0.75rem;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  transition: transform 200ms ease, border-color 200ms ease, background-color 200ms ease;
}

.share-item:hover {
  transform: translateY(-1px);
  border-color: #cbd5e1;
  background-color: #f8fafc;
}

.share-item:focus-visible {
  outline: 2px solid #1f2a44;
  outline-offset: 2px;
}
</style>
